import { useLocation } from "react-router";

const useTituloPagina = () => {
  const location = useLocation();

  const renderSwitchTitlePage = () => {
    switch (true) {
      case location.pathname === "/Login":
        return "Login";
      case location.pathname === "/portal/Inicio":
        return "Inicio";
      case location.pathname === "/portal/Estudios":
        return "Estudios paciente";
      case location.pathname === "/portal/Turnos":
        return "Turnos paciente";
      case location.pathname === "/portal/Horarios":
        return "Horarios profesionales";
      case location.pathname === "/portal/Datos":
        return "Horarios profesionales";
      case location.pathname === "/portal/Reservar turno" ||
        location.pathname === "/portal/Reservar turno/" ||
        location.pathname === "/portal/Reservar%20turno/" ||
        location.pathname === "/portal/Reservar%20turno":
        return "Reservar turno";
      default:
        return "Ubicacion no reconocida";
    }
  };


  const renamePage = () => {
    const titulo = renderSwitchTitlePage();
    document.title = (titulo ? titulo : "Portal") + " - Portal de Pacientes Integrado";
  };

  renamePage();
};

export default useTituloPagina;
